<template>
  <div>
    <v-row dense v-for="(p, pi) in partType.parts" :key="'p' + pi" :class="partType.partClass">
      <v-col v-if="p.usesAttributes"><v-row dense>
          <v-col v-for="(dpa, ai) in p.attributes" :key="'p' + pi + 'a' + ai" :cols="dpa.cols">
            <DocumentTagSummary v-if="dpa.tagValues?.length" :DocumentPartAttribute="dpa">
            </DocumentTagSummary>
            <span v-else v-html="dpa.text" :class="{
              ListPart:
                ai === 0 &&
                (partType.moveable || partType.type === 'listitem'),
            }"></span>
          </v-col>
        </v-row></v-col>
      <v-col v-else><v-row dense v-for="(s, si) in p.sub_parts" :key="'p' + pi + 's' + si">
          <v-col><span v-html="s.text" :class="{
            ListPart: partType.moveable || s.type === 'listitem',
          }"></span></v-col> </v-row></v-col><v-col cols="2" v-if="partType.uses_essential_flag">
        <v-chip small class="float-right mb-1">{{ p.essential }}
        </v-chip></v-col>
      <v-col cols="12" v-if="p.childPartTypes && p.childPartTypes.length" class="pl-4 py-0">
        <DocSummaryPartType v-for="(cpt, cpti) in p.childPartTypes" :key="'cpt' + cpti" :partType="cpt">
        </DocSummaryPartType>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DocumentTagSummary from "@/components/document/DocumentTagSummary";

export default {
  name: "DocSummaryPartType",
  props: {
    partType: { type: Object, required: true },
  },
  components: {
    DocumentTagSummary,
  },
};
</script>
<style scoped>
</style>
